// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://acxjwosgugimmhfwdhks.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFjeGp3b3NndWdpbW1oZndkaGtzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNDUzMjksImV4cCI6MjA2MzkyMTMyOX0.jXRshIDoyGg5G1qCBgau36FTBdRjmQkkVoISPZi1bko";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});